import {useEffect} from "react";
import Background from "../../assets/newbg.jpg";

const useBackgroundImage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

        const style = document.createElement("style");
        style.innerHTML = `
            body::before {
                content: "";
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
                background-image: url(${Background});
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                z-index: -1;
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []); // Rende il codice reattivo al cambiamento dell'immagine
};

export default useBackgroundImage;
